<template>
	<div>
		<div class="alert-background" v-if="has_item">


			<div class="alert shadowed" v-if="alert_item">
				<div class="alert-header" v-if="alert_item.header">
					{{ alert_item.header }}
				</div>
				<div class="alert-body">
					{{ alert_item.text }}
				</div>
				<div class="alert-footer">
					<button class="alert-button" @click="dismiss_alert(alert_item)">
						OK <i class="fa fa-check"></i>
					</button>
				</div>
			</div>

			

			<div class="alert shadowed" v-if="confirm_item">
				<div class="alert-header" v-if="confirm_item.header">
					{{ confirm_item.header }}
				</div>
				<div class="alert-body">
					{{ confirm_item.text }}
				</div>
				<div class="alert-footer">
					<button class="alert-button-cancel" @click="dismiss_confirm(confirm_item, false)">
						<i class="fa fa-times"></i> NÃO
					</button>
					<button class="alert-button" @click="dismiss_confirm(confirm_item, true)">
						SIM <i class="fa fa-check"></i>
					</button>
				</div>
			</div>




			<div class="alert shadowed" v-if="prompt_item">
				<div class="alert-header" v-if="prompt_item.header">
					{{ prompt_item.header }}
				</div>
				<div class="alert-body">
					{{ prompt_item.text }}
					
					<br/><br/>
					<div class="alert-input-wrapper">
						<i class="fa fa-keyboard"></i>
						<input 
						ref="prompt_input"
						class="alert-input" 
						:type="prompt_item.input.type" 
						:required="prompt_item.input.required"
						:placeholder="prompt_item.input.placeholder"
						@keydown.enter.prevent="dismiss_prompt(prompt_item, true)"
						>
					</div>
					<br/>

				</div>
				<div class="alert-footer">

					<button 
					class="alert-button-cancel" 
					@click="dismiss_prompt(prompt_item, false)"
					>
						<i class="fa fa-times"></i> CANCELAR
					</button>

					<button 
					class="alert-button" 
					@click="dismiss_prompt(prompt_item, true)"
					:disabled="prompt_item.input.required && $refs.prompt_input.value.length == 0">
						OK <i class="fa fa-check"></i>
					</button>

				</div>
			</div>





		</div>
	</div>
</template>


<script>
	export default {
		name: "Alert",

		data: function() {
			return this.$alert.data;
		},

		methods: {
			dismiss_alert: function(item) {
				for (let idx in this.alerts) {
					if (this.alerts[idx] == item) {
						this.alerts[idx].callback();
						this.alerts.splice(idx, 1);
					}
				}
			},

			dismiss_confirm: function(item, result) {
				for (let idx in this.confirms) {
					if (this.confirms[idx] == item) {
						this.confirms[idx].callback(result);
						this.confirms.splice(idx, 1);
					}
				}
			},

			dismiss_prompt: function(item, result) {
				for (let idx in this.prompts) {
					if (this.prompts[idx] == item) {
						if (result) {
							if (this.prompts[idx].input.required && this.$refs.prompt_input.value.length == 0) {
								this.$refs.prompt_input.setCustomValidity("Campo obrigatório.");
								this.$refs.prompt_input.focus();
								return;
							}
							result = this.$refs.prompt_input.value;
						}

						this.prompts[idx].callback(result);
						this.prompts.splice(idx, 1);
					}
				}
			}
		},

		computed: {
			has_item: function() {
				return (this.alerts.length > 0 || this.confirms.length > 0 || this.prompts.length > 0)
			},

			alert_item: function() {
				if (this.alerts.length == 0) {
					return false;
				} else {
					return this.alerts[0];
				}
			},

			confirm_item: function() {
				if (this.confirms.length == 0) {
					return false;
				} else {
					return this.confirms[0];
				}
			},

			prompt_item: function() {
				if (this.prompts.length == 0) {
					return false;
				} else {
					return this.prompts[0];
				}
			},
		}
	}
</script>


<style scoped>

.alert-background {
	background: #22222222;
	position: fixed;
	z-index: 1000;
	width: 100vw;
	height: 100vh;
	left: 0;
	top: 0;
}

.alert {
	position: fixed;
	top: 15px;
	left: 0;
	right: 0;
	background: #222;
	margin: auto;
	width: 500px;
	color: #fff;
	border-radius: 4px;
	padding: 15px;
}

.alert-header {
	width: 100%;
	font-weight: bold;
	margin-bottom: 15px;
}

.alert-body {
	width: 100%;
	margin-bottom: 15px;
	font-size: 14px;
}

.alert-footer {
	width: 100%;
}

.alert-button {
	width: 120px;
	height: 30px;
	float: right;
	border: none;
	background: #fff;
	font-weight: bold;
}

.alert-button-cancel {
	width: 120px;
	height: 30px;
	float: left;
	border: none;
	background: #fff;
	font-weight: bold;
}




.alert-input-wrapper {
	position: relative;
	margin-top: 15px;
}

.alert-input-wrapper > i {
	position: absolute;
	color: #999;
	font-size: 20px;
	width: 40px;
	height: 40px;
	text-align: center;
	line-height: 40px;
}

.alert-input {
	width: 100%;
	height: 40px;
	line-height: 40px;
	border: none;
	padding-left: 45px;
}

</style>